import { addNewRelicPageAction } from 'ddc-new-relic';

const wsTrackNr = (eventType) => {
	if (Math.floor(Math.random() * (100 - 0) + 1) <= 10) {
		addNewRelicPageAction('wsTrackingDebug', {
			eventName: eventType,
			userSessionId: sessionStorage?.getItem('wsTrackingSessionId')
		});
	}
};

export const wsTrackNrClickPathMissing = () => {
	addNewRelicPageAction('wsTrackingClickPathMissing', {
		eventName: 'ddc.form.confirmation',
		userSessionId: sessionStorage?.getItem('wsTrackingSessionId')
	});
};

export const wsTrackNrBlockedFormConfirmation = (formEventId) => {
	addNewRelicPageAction('wsTrackNrBlockedFormConfirmation', {
		eventName: 'ddc.form.confirmation',
		formEventId,
		userSessionId: sessionStorage?.getItem('wsTrackingSessionId')
	});
};

export default wsTrackNr;
